import { useEffect } from 'react';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { errorMessages } from '@/utils/errorMessages';

const MIN_FOCUS_INTERVAL_MS = 3000;

export default function useVersionSkewProtection() {
  const { t } = useTranslation();

  useEffect(() => {
    const checkVersion = async () => {
      const buildId = (window as unknown as { __NEXT_DATA__?: { buildId?: string } }).__NEXT_DATA__?.buildId;
      if (!buildId) return;

      try {
        const res = await fetch(`/_next/static/${buildId}/_buildManifest.js`, {
          method: 'HEAD',
          cache: 'no-store',
        });
        if (res.status === 404) {
          toast.warn(t(`errorMessages.${errorMessages.versionSkewReload}`), {
            toastId: 'version-skew',
            autoClose: false,
          });
        }
      } catch {
        // network error — ignore
      }
    };

    let blurTime: number | null = null;

    const onBlur = () => {
      blurTime = Date.now();
    };
    const onFocus = () => {
      if (blurTime !== null && Date.now() - blurTime >= MIN_FOCUS_INTERVAL_MS) {
        checkVersion();
      }
      blurTime = null;
    };
    const onPageShow = (e: PageTransitionEvent) => {
      if (e.persisted) checkVersion();
    };

    window.addEventListener('blur', onBlur);
    window.addEventListener('focus', onFocus);
    window.addEventListener('pageshow', onPageShow);
    return () => {
      window.removeEventListener('blur', onBlur);
      window.removeEventListener('focus', onFocus);
      window.removeEventListener('pageshow', onPageShow);
    };
  }, [t]);
}
